import React from 'react';
import i18n from '@nextroll/ar-i18n';

import { Placements, Tooltip, Popper } from '@nextroll/ar-style-base';
import { IContactByFilterContact } from 'api/workflowsApi';

interface AccountActionPreviewContactInfoTooltipProps {
  row: IContactByFilterContact;
  shouldMaskIcons?: boolean;
}

export const AccountActionPreviewContactInfoTooltip:
  React.FC<AccountActionPreviewContactInfoTooltipProps> = ({ row, shouldMaskIcons }) => {
      const createIconWithTooltip = (
          isAvailable: boolean,
          tooltipMessage: { available: string; notAvailable: string },
          iconClass: string,
          key: string
      ) => {
          const message = isAvailable ? tooltipMessage.available : tooltipMessage.notAvailable;
          const iconStyle = isAvailable ? {} : { opacity: 0.3 };
          const icon = <i className={iconClass} style={iconStyle} />;

          const tooltip = (
              <Tooltip
                  className='workflow-node-panel-contact-info-tooltip'
                  placement={Placements.TOP}
              >
                  {message}
              </Tooltip>
          );

          if (shouldMaskIcons) {
              return <span key={key} className='workflow-node-masked-cell'>{icon}</span>;
          }
          return <Popper key={key} hoverContent={tooltip}>{icon}</Popper>;
      };

      const icons = [
          createIconWithTooltip(
              row.has_email,
              {
                  available: i18n.gettext('Email is available'),
                  notAvailable: i18n.gettext('No Email available')
              },
              'far fa-envelope',
              'email'
          ),
          createIconWithTooltip(
              row.has_direct_number,
              {
                  available: i18n.gettext('Direct Number is available'),
                  notAvailable: i18n.gettext('No Direct Number available')
              },
              'far fa-phone',
              'direct'
          ),
          createIconWithTooltip(
              row.has_mobile_number,
              { available: i18n.gettext('Mobile Number is available'),
                  notAvailable: i18n.gettext('No Mobile Number available')
              },
              'far fa-mobile',
              'mobile'
          ),
      ];

      return (
          <div className='workflow-node-panel-account-action-contact-info-icons'>
              {icons}
          </div>
      );
  };
